import { render, staticRenderFns } from "./MoveToFixedSequencesList.vue?vue&type=template&id=3bc276b2&scoped=true"
import script from "./MoveToFixedSequencesList.vue?vue&type=script&lang=js"
export * from "./MoveToFixedSequencesList.vue?vue&type=script&lang=js"
import style0 from "./MoveToFixedSequencesList.vue?vue&type=style&index=0&id=3bc276b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc276b2",
  null
  
)

export default component.exports